import React, { useState, useRef, useEffect } from "react";
import styled from 'styled-components';
import TextButton from "components/TextButton";
import FormField from "components/FormField";
import StacInterface from "utils/StacInterface";

const Header = styled.div`
  margin: 0 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    font-size: 18px;
    line-height: 22px;
    color: #E5E5E5;
    font-weight: 400;
  }
`;

const Description = styled.p`
  font-family: Open Sans;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #A0A0A0;
  margin: 24px 0;
`;

const WarningToken = styled.div`
  h2 {
    font-family: Roboto;    
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    color: #E5E5E5;
    margin-bottom: 16px;
  }

  input {
    background: #2F2F2F;
    border: 1px dashed #A0A0A0;
    border-radius: 3px;
    font-family: Roboto;
    font-weight: 500;
    font-size: 15px;
    line-height: 23px;
    color: #707173;

    &.active {
      border: 1px dashed #E5E5E5;
      color: #E5E5E5;
    }
  }

  .custom-alert {
    margin-top: 16px;
    border-radius: 3px;
    padding: 16px 21px;
    display: flex;

    .text {
      font-family: Roboto;
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      margin-left: 22px;
    }
  }

  .warning-alert {
    background: rgba(228, 171, 84, 0.5);    
    color: #E4AB54;    
  }

  .success-alert {
    background: rgba(21, 198, 125, 0.5);   
    color: #15C67D;
  }

`;

const CreateToken = ({ tokens, setIsCreateable }) => {
  const [newToken, setNewToken] = useState({});
  const tokenRef = useRef();

  const [tokenCreated, setTokenCreated] = useState(true);
  const [tokenCopied, setTokenCopied] = useState(false);

  useEffect(() => {
    StacInterface.instance.generateAPIKey().then((resp) => {
      setNewToken(resp.data)
    })
  }, [])

  const createToken = () => {
    setTokenCreated(true);

    StacInterface.instance.updateAPIKey(newToken).then(() => {
      setIsCreateable(false);
    })
  };

  const handleChangeToken = (value, name) => {
    setNewToken({ ...newToken, [name]: value });
  };

  const copyToClipboard = (e) => {
    tokenRef.current.select();
    document.execCommand('copy');
    e.target.focus();
    setTokenCopied('Copied!');
  }

  return (
    <>
      <Header>
        <h2>Add API Key</h2>
        <TextButton onClick={createToken} text="Create" disabled={newToken.name === '' ? true : false} />
      </Header>
      <FormField label="Token Name" id="endpoint-name">
        <input
          id="endpoint-name"
          type="text"
          placeholder="API Key"
          value={newToken.name}
          onChange={(e) => handleChangeToken(e.target.value, 'name')}
        />
      </FormField>
      {
        !tokenCreated &&
        <Description>
          Name your Endpoint for the endpoint URL and click CREATE.
        </Description>
      }
      {
        tokenCreated &&
        <WarningToken>
          <h2>Auth API Key</h2>
          <div onClick={copyToClipboard}>
            <input type="text" value={newToken.api_key} readOnly ref={tokenRef} className={tokenCopied ? 'active' : ''} />
          </div>
          {
            !tokenCopied ?
              <div className="warning-alert custom-alert">
                <span className="material-icons-outlined">warning_amber</span>
                <span className="text">Click on the API Key to copy to clipboard. You will not have access to the token later.</span>
              </div> :
              <div className="success-alert custom-alert">
                <span className="material-icons-outlined">warning_amber</span>
                <span className="text">Copied to clipboard! Please paste to a secure location to save for future use.</span>
              </div>
          }
        </WarningToken>
      }
    </>
  );
};

export default CreateToken;
